export interface AccuracyRunConfigParts {
  batchType: string | null;
  modelLabel: string | null;
  promptName: string | null;
  /** Git commit SHA the prompt was pinned to — displayed short. */
  promptSha: string | null;
}

/**
 * `"Validation · Claude Sonnet 5 · stroke experimental · abc1234"` — the run's
 * batch, model, prompt path (segments spaced) and short commit SHA joined with a
 * middot. Missing parts are dropped so a partially-populated row still reads
 * cleanly; returns `''` when nothing is known.
 */
// TODO: cleanup with cp_trigger_accuracy_from_ui ff
export const formatAccuracyRunConfig = ({
  batchType,
  modelLabel,
  promptName,
  promptSha,
}: AccuracyRunConfigParts): string =>
  [batchType, modelLabel, promptName?.replace(/\//g, ' '), promptSha?.slice(0, 7)]
    .filter((part): part is string => Boolean(part))
    .join(' · ');
